/**
 * Dept-filter predicate for the Manage Visit queue list (TOKEN-UPDATE/T2, S1).
 *
 * Distinct from `deptMembershipFilter.js` (admin catalog MEMBERSHIP semantic,
 * which hides org-wide rows under a specific dept).
 *
 * STRICT semantics (GATE 3 RULING, owner, 2026-07-30 — explicit reversal of the
 * earlier RC5 carve-out): when a specific department is selected, only visits
 * whose `department_id` equals it match. A visit with no department
 * (unassigned) is EXCLUDED once a specific department is selected — it is
 * visible only under "All" (falsy `deptId`). An EMERGENCY-visit carries the
 * literal string sentinel `'EMERGENCY'` in `department_id` (see
 * `EMERGENCY_DEPT_SENTINEL`, departmentResolution.js) — never a real
 * `dept_id` — so plain equality already excludes it from every specific-dept
 * selection, same as unassigned; no special-casing needed here.
 */
export function visitMatchesDeptFilter(visit, deptId) {
  if (!deptId) return true;
  return visit?.department_id === deptId;
}
